import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import BrandMark from "@/components/BrandMark";
import NewsletterSignup from "@/components/NewsletterSignup";

export default function Footer() {
    return (
        <footer className="bg-navy-deep text-cream pt-20 pb-10 px-6 md:px-12 border-t border-gold/30 relative overflow-hidden">
            <div className="absolute inset-0 bg-grain opacity-50 pointer-events-none" />
            <div className="max-w-7xl mx-auto relative">
                <div className="grid md:grid-cols-3 gap-12 mb-12">
                    <div>
                        <div className="mb-4">
                            <BrandMark variant="navbar" />
                        </div>
                        <p className="text-sm text-cream/70 font-outfit leading-relaxed max-w-sm">
                            Luxury cleaning redefined. We treat your space like our own — with premium products, attention to detail, and a 100% satisfaction guarantee.
                        </p>
                        <NewsletterSignup />
                    </div>

                    <div>
                        <h4 className="font-playfair text-lg text-gold mb-5 uppercase tracking-wider">Services</h4>
                        <ul className="space-y-2 text-sm text-cream/80 font-outfit">
                            <li>Home Cleaning</li>
                            <li>Office Cleaning</li>
                            <li>End of Tenancy</li>
                            <li>Deep Cleaning</li>
                            <li>Window Cleaning</li>
                            <li className="pt-2 border-t border-cream/10 mt-2"><Link to="/rewards" className="hover:text-gold" data-testid="footer-rewards-link">Loyalty Rewards</Link></li>
                            <li><Link to="/gift" className="hover:text-gold" data-testid="footer-gift-link">Gift Vouchers</Link></li>
                        </ul>
                    </div>

                    <div id="contact">
                        <h4 className="font-playfair text-lg text-gold mb-5 uppercase tracking-wider">Contact</h4>
                        <ul className="space-y-3 text-sm text-cream/80 font-outfit">
                            <li className="flex items-start gap-3">
                                <Phone className="w-4 h-4 text-gold mt-0.5 shrink-0" />
                                <div>
                                    <a href="tel:+353838798812" data-testid="footer-phone-1" className="hover:text-gold block">+353 838 798 812</a>
                                    <a href="tel:+353899826029" data-testid="footer-phone-2" className="hover:text-gold block">+353 899 826 029</a>
                                </div>
                            </li>
                            <li className="flex items-start gap-3">
                                <Mail className="w-4 h-4 text-gold mt-0.5 shrink-0" />
                                <a href="mailto:bookings@signatureshineandco.ie" data-testid="footer-email" className="hover:text-gold break-all">bookings@signatureshineandco.ie</a>
                            </li>
                            <li className="flex items-start gap-3">
                                <MapPin className="w-4 h-4 text-gold mt-0.5 shrink-0" />
                                <span>Serving Ireland — Dublin & surrounding areas</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="gold-divider mb-6" />
                <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-cream/50 font-outfit">
                    <span>© {new Date().getFullYear()} Signature Shine & Co. All rights reserved.</span>
                    <div className="flex items-center gap-6">
                        <a href="/privacy" data-testid="footer-privacy" className="hover:text-gold uppercase tracking-wider">Privacy</a>
                        <a href="/terms" data-testid="footer-terms" className="hover:text-gold uppercase tracking-wider">Terms</a>
                        <a href="/refund-policy" data-testid="footer-refund" className="hover:text-gold uppercase tracking-wider">Refunds</a>
                    </div>
                    <span className="italic font-playfair text-gold/80">We&apos;ve got you covered.</span>
                </div>
            </div>
        </footer>
    );
}
